"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooAbilityHandler = exports.BooActorAbilityFactory = exports.BooAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class BooAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Boo;
        this.__typeName = "Boo";
    }
}
exports.BooAbilityArgs = BooAbilityArgs;
let BooActorAbilityFactory = class BooActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Boo", "AllEnemies", 0);
    }
};
BooActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Boo")
], BooActorAbilityFactory);
exports.BooActorAbilityFactory = BooActorAbilityFactory;
let BooAbilityHandler = class BooAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const targets = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackerId: ability.invokerId,
            attackType: "magic",
            projectiles: targets.map(targetId => ({
                targetId,
                path: "line",
                type: "BlackSmoke",
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Death", 40)
                ],
            })),
            onHit(sequence, _attack, _damages, { targetId }) {
                if ((0, Random_1.randomPercent)() <= 50) {
                    container.applyDebuff({
                        attackerId: ability.invokerId,
                        targetId,
                        sequence,
                        duration: Duration_1.Duration.Turns(1),
                        effect: new core_1.StunEffectArgs(),
                        onAppliedOrResisted: (sequence, { targetId }, applied) => {
                            sequence.push(new core_2.InstantVfxStepArgs(applied ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "head")
                                : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "DarkLightning"));
                        },
                    });
                }
            },
        });
    }
};
BooAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Boo)
], BooAbilityHandler);
exports.BooAbilityHandler = BooAbilityHandler;
